import { Button } from '@material-ui/core';
import { httpApi } from '@nucleus-care/nucleuscare-backend-client';
import { useModal } from 'components/UI';
import { useEffect, useState } from 'react';
import { Spinner } from 'react-activity';
import AuthStore from 'stores/AuthStore';
import { UserConfig } from 'stores/UserStore';
import styled from 'styled-components';
import { PatientDetail, patientDetailStore } from 'zustand/patientDetailStore';

const Container = styled.div`
  border-radius: 8px;
  position: relative;
`;

const Modal = styled.div<{ isOpen: boolean }>`
  display: ${props => (props.isOpen ? 'block' : 'none')};
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);
  padding-top: 60px;
`;

const ModalContent = styled.div`
  background-color: #fefefe;
  margin: 5% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  max-width: 500px;
  border-radius: 8px;
`;

const TextArea = styled.textarea`
  width: 100%;
  height: 100px;
  font-size: 16px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: none;
`;

const FullWidthContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const InfoTextLimit = styled.span<{ limit?: boolean }>`
  color: ${props => (props.limit ? 'red' : 'black')};
  font-size: 0.6em;
  display: block;
  margin-left: 2px;
  text-align: left;
`;

export const PatientQuickNotes = ({ patientDetails }: { patientDetails: PatientDetail | undefined }) => {
  console.log('PatientQuickNotes', patientDetails);
  const { isOpen, openModal, closeModal } = useModal();
  const userId = AuthStore.getUserID();
  const [userInfo, setUserInfo] = useState<UserConfig | undefined>();
  const [quickNote, setQuickNote] = useState<string>();

  const { fetch: fetchPatientDetails, updateQuickNote, setDetails, fetching, updatingQuickNote } = patientDetailStore(store => store);

  const fetchUserConfig = () => {
    httpApi
      .get(`/user/${userId}/config`)
      .then(({ data }) => {
        setUserInfo(data);
      })
      .catch(e => {
        console.warn('Error getting user Information', e);
      });
  };

  useEffect(() => {
    fetchUserConfig();
    setDetails(patientDetails);
  }, []);

  useEffect(() => {
    setQuickNote(patientDetails?.QuickNote ?? '');
  }, [isOpen]);

  const isEditable = userInfo?.CanEditQuickNotes;
  const isQuickNoteLengthExceeded = quickNote?.length > 200;
  const onSave = async () => {
    await updateQuickNote(quickNote);
    await fetchPatientDetails();
    closeModal();
  };
  return (
    <Container>
      <Modal isOpen={isOpen}>
        <ModalContent>
          <h5>Quick Notes</h5>

          <TextArea
            onChange={e => {
              setQuickNote(e.target.value);
            }}
            disabled={!isEditable}
            value={quickNote}
          />
          <InfoTextLimit limit={isQuickNoteLengthExceeded}>{quickNote?.length ?? 0}/200</InfoTextLimit>
          <FullWidthContainer>
            <Button variant="outlined" onClick={closeModal}>
              Close
            </Button>
            {isEditable && (
              <Button disabled={isQuickNoteLengthExceeded || updatingQuickNote} color="primary" variant="contained" onClick={onSave}>
                {updatingQuickNote ? <Spinner /> : 'Save'}
              </Button>
            )}
          </FullWidthContainer>
        </ModalContent>
      </Modal>

      <Button variant="outlined" onClick={openModal}>
        Quick Notes
      </Button>
    </Container>
  );
};
